import { createFhirResource, Bundle } from '@/fhirworks';

export function transformFhirResponse(res) {
    if (res.data.total) {
        res.total = res.data.total;
    }

    if (res.data?.data) {
        res.data.entry = res.data.data;
        res.data.resourceType = 'Bundle';
    }

    if (res.data?.entry && res.data.resourceType === 'Bundle') {
        res.originalData = JSON.parse(JSON.stringify(res.data));
        res.bundle = new Bundle(res.data);
        let entries = res.bundle.entry.slice();
        res.data = entries.map((entry) => entry.resource);

        for (let innerEntry of res.data.filter((e) => e?.entry?.[0]?.resource)) {
            let entryList = innerEntry.entry.slice();
            innerEntry.entry = entryList.map((entry) => createFhirResource(entry.resource.resourceType, entry.resource, entry._group));
        }
    } else if (res.data && res.data.resourceType) {
        res.originalData = res.data;
        res.data = createFhirResource(res.data.resourceType, res.data);
    }

    return res;
}
